/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by sjacobs on 1/21/19.
 */
function JsonViewerModalController(
    this: JS5Object,
    _: JS5Object,
    $q: JS5Object,
    $routeParams: JS5Object,
    NotificationService: JS5Object
) {

    this.$onInit = () => {
        this.jsonDataPromise = $q.when(this.resolve.jsonData);
    };

    this.onCopyContextDataClicked = () => {
        if (!_.isNil(navigator.clipboard)) {
            console.warn('Navigator available. Copying to clipboard using Clipboard API');
            navigator.clipboard.writeText(JSON.stringify(this.resolve.jsonData))
                .then(function () {
                    NotificationService.createSuccessNotification('Copied Context JSON Data to clipboard successfully', 2000);
                }, function () {
                    NotificationService.createFailureNotification('Unable to copy Context JSON Data to clipboard', '', true, -1);
                });
        } else {
            console.warn('Navigator not available. Copying to clipboard using document.execCommand');
            const input = document.createElement('input');
            document.body.appendChild(input);
            input.value = JSON.stringify(this.resolve.jsonData);
            input.focus();
            input.select();
            const result = document.execCommand('copy');
            input.remove();
            if (result) {
                NotificationService.createSuccessNotification('Copied Context JSON Data to clipboard successfully', 2000);
            } else {
                NotificationService.createFailureNotification('Unable to copy Context JSON Data to clipboard', '', true, -1);
            }
        }
    };
}

angular.module('prism-ui.components').component(
    'jsonViewerModal',
    {
        controller: JsonViewerModalController,
        templateUrl: 'components/modal/jsonViewerModal/json-viewer-modal-template.html',
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    }
);
